import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faBars,
  faTimes,
  faBell,
  faUser,
  faSignOutAlt
} from '@fortawesome/free-solid-svg-icons';
import {
  Navbar,
  Container,
  Button,
  Badge,
  Dropdown,
  Image
} from '@themesberg/react-bootstrap';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { logout } from '../../redux/actions/auth';
import { Routes } from '../../routes';
import Profile3 from '../../assets/img/default_avatar.png';
import MobileSidebar from './MobileSidebar';

const MobileNavbar = ({ notifications = [], unreadCount = 0 }) => {
  const [showSidebar, setShowSidebar] = useState(false);
  const user = useSelector((state) => state.auth.user);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleLogout = () => {
    dispatch(logout(() => navigate(Routes.Signin.path)));
  };

  const toggleSidebar = () => {
    setShowSidebar(!showSidebar);
  };

  return (
    <>
      <Navbar 
        className="mobile-navbar d-block d-lg-none bg-primary fixed-top"
        style={{ zIndex: 1030 }}
      >
        <Container fluid className="px-3">
          <div className="d-flex justify-content-between align-items-center w-100">
            {/* Menu Toggle */}
            <Button
              variant="link"
              className="text-white p-0 mobile-menu-toggle"
              onClick={toggleSidebar}
              style={{ fontSize: '1.25rem' }}
            >
              <FontAwesomeIcon icon={faBars} />
            </Button>

            {/* Brand */}
            <Navbar.Brand className="text-white fw-bold mx-auto" style={{ fontSize: '1rem' }}>
              KIFMIS
            </Navbar.Brand>

            {/* Right Actions */}
            <div className="d-flex align-items-center">
              {/* Notifications */}
              <Button
                variant="link"
                className="text-white p-0 me-3 position-relative"
                onClick={() => navigate(Routes.Notifications.path)}
              >
                <FontAwesomeIcon icon={faBell} />
                {unreadCount > 0 && (
                  <Badge 
                    bg="danger" 
                    className="position-absolute top-0 start-100 translate-middle rounded-pill"
                    style={{ fontSize: '0.6rem' }}
                  >
                    {unreadCount > 99 ? '99+' : unreadCount}
                  </Badge>
                )}
              </Button>

              {/* User Menu */}
              <Dropdown align="end">
                <Dropdown.Toggle
                  as={Button}
                  variant="link"
                  className="text-white p-0 border-0"
                  style={{ boxShadow: 'none' }}
                >
                  <Image
                    src={Profile3}
                    className="rounded-circle"
                    width="32"
                    height="32"
                  />
                </Dropdown.Toggle>
                
                <Dropdown.Menu className="mt-2">
                  <Dropdown.Item
                    onClick={() => navigate(Routes.pv.UserProfile)}
                  >
                    <FontAwesomeIcon icon={faUser} className="me-2" />
                    Profile
                  </Dropdown.Item>
                  <Dropdown.Divider />
                  <Dropdown.Item onClick={handleLogout}>
                    <FontAwesomeIcon icon={faSignOutAlt} className="me-2" />
                    Logout
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </div>
          </div>
        </Container>
      </Navbar>

      {/* Mobile Sidebar */}
      <MobileSidebar 
        show={showSidebar} 
        onHide={() => setShowSidebar(false)}
        user={user}
      />
    </>
  );
};

export default MobileNavbar;